<template>
  <div class="shipment-detail" :key="triage">
    <div>
      <div
        class="list-group-messages pb-5"
        style="height: 63vh; overflow-y: scroll; overflow-x: hidden"
      >
        <VanTrucking
          ref="van"
          :bookingId.sync="bookingId"
          :key="countRq"
          v-if="request_quotation.service_type == 6"
          :request_quotation.sync="request_quotation"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :shipment_details="shipment_details"
        />
        <ContainerTrucking
          ref="containerTrucking"
          :key="countRq"
          :bookingId.sync="bookingId"
          v-if="request_quotation.service_type == 5"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :shipment_details="shipment_details"
          :request_quotation.sync="request_quotation"
        />
        <AIR
          ref="AIR"
          @cut-off="setCutOff"
          v-if="request_quotation.service_type == 1"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :request_quotation.sync="request_quotation"
        />
        <LCL
          :bookingId.sync="bookingId"
          ref="LCL"
          @cut-off="setCutOff"
          :proc_code="proc_code"
          v-if="request_quotation.service_type == 3"
          :key="countRq"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :shipment_details="shipment_details"
          :request_quotation.sync="request_quotation"
          :tempViewBooking="tempViewBooking"
        />
        <FCL
          ref="FCL"
          @cut-off="setCutOff"
          v-if="request_quotation.service_type == 2"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :request_quotation="request_quotation"
        />

        <Customs
          ref="Customs"
          @cut-off="setCutOff"
          v-if="request_quotation.service_type == 4"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :request_quotation="request_quotation"
        />
      </div>
    </div>
    <!-- v-if="request_quotation.status_id != 63" -->
    <div class="custom-mt">
      <div class="float-right">
        <b-button
          variant="primary"
          @click="handPutUnlock"
          v-if="
            request_quotation &&
            request_quotation.accept_edit == 1 &&
            request_quotation.locked == 1 &&
            request_quotation.status_id == 9 &&
            userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin
          "
          class="btn btn-custom-round float-right mr-2"
        >
          Unlock
        </b-button>

        <b-button
          variant="primary"
          @click="handPutShipmentDetail"
          v-if="
            request_quotation &&
            request_quotation.shipment_on_tms == null &&
            request_quotation.accept_edit == 1 &&
            request_quotation.locked != 1 &&
            (userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin ||
              userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin_Sale)
          "
          class="btn btn-custom-round float-right mr-2"
        >
          Update
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { $ctx } from "@themeConfig";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import LCL from "./form-details/LCL.vue";
import AIR from "./form-details/AIR.vue";
import { Utils } from "@core/utils/utilsCustom";
import { mapState, mapActions } from "vuex";
import { checkDateToFormatDynamic } from "@/utils/format";

export default {
  props: {
    step: { default: "booking" },
    shipmentOnTms: { default: null },
    shipmentOnFast: { default: null },
    shipmentDetail: { default: null },
    request_quotation: { default: null },
    readonly: { default: true },
    bookingId: { default: null },
    proc_code: {
      default: null,
    },
    tempViewBooking: {
      default: null,
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    Select2,
    vueDropzone: vue2Dropzone,
    VanTrucking: () => import("./form-details/VanTrucking.vue"),
    ContainerTrucking: () => import("./form-details/ContainerTrucking.vue"),
    LCL,
    AIR,
    FCL: () => import("./form-details/FCL.vue"),
    Customs: () => import("./form-details/Customs.vue"),
  },
  data() {
    return {
      typeRef: {
        6: "van",
        5: "containerTrucking",
        1: "AIR",
        3: "LCL",
        2: "FCL",
        4: "Customs",
      },
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      quotationInfo: null,
      totalFiles: 0,
      triage: 0,
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      shipment_details: {},
      shipment_on_tms: {
        id: "",
        customer_name: null,
        sale_id: null,
        customer_id: null,
        shipper: null,
      },

      shipment_on_fast: {
        etd: null,
        eta: null,
      },
      countRq: 0,
    };
  },
  computed: {
    ...mapState("masterData", [
      "locations",
      "sales",
      "cont_types",
      "goods_types",
      "regions",
    ]),
  },
  created() {},

  mounted() {
    this.isHideShow =
      this.request_quotation.other_pickup_location != null ? true : false;

    this.isHideShowPk =
      this.request_quotation.other_delivery_location != null ? true : false;

    this.isHideShow =
      this.request_quotation.other_pickup_region != null ? true : false;

    this.isHideShowPk =
      this.request_quotation.other_delivery_region != null ? true : false;
    // useJwt
    //     .get("wr1?objectType=GetBookingDetail", {
    //         params: { search: { id: this.bookingId } },
    //     })
    //     .then((response) => {
    //         if (response?.data?.result?.shipment_on_tms_info != null) {
    //             this.shipment_on_tms = JSON.parse(
    //                 response.data.result.shipment_on_tms_info
    //             );
    //             this.readonlyFrom = true;
    //         }
    //         if (response.data.result.shipment_on_fast_info != null) {
    //             this.shipment_on_fast = JSON.parse(
    //                 response.data.result.shipment_on_fast_info
    //             );
    //         }
    //         if (response.data.result.shipment_detail != null) {
    //             this.shipment_details = JSON.parse(
    //                 response.data.result.shipment_detail
    //             );
    //         }

    //         if (response.data.result.shipment_info_all != null) {
    //             this.request_quotation.shipment_info = JSON.parse(
    //                 response.data.result.shipment_info_all
    //             );
    //         }

    //     });
    this.getListKH();
    this.$nextTick(() => {
      this.countRq++;
    });

    this.shipment_details = this.shipmentDetail;
    this.shipment_on_tms = this.shipmentOnTms;
    this.shipment_on_fast = this.shipmentOnFast;
  },
  methods: {
    getListKH() {
      this.$store.dispatch(
        "masterData/fetchCustomerListCompany",
        this.shipment_on_tms.customer_company_id
      );
    },
    setCutOff(n) {
      this.request_quotation.cut_off = n;
    },
    disabledRangeDelivery: function (date) {
      if (this.request_quotation.pick_up_date) {
        var mydate = moment(this.request_quotation.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
    handPutUnlock() {
      this.$loading.show();

      useJwt
        .put("wr1?objectType=UpdateLockedBooking", {
          id: this.bookingId,
        })
        .then((response) => {
          this.request_quotation.locked = 0;
          this.$swal({
            icon: "success",
            title: "Unlock successfully",
          });
          this.triage++;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    handPutShipmentDetail() {
      const data =
        this.$refs[this.typeRef[this.request_quotation.service_type]]
          .shipment_detail;

      if (data.service_type.toString() == "6") {
        data.valueVan.forEach((item, idx) => {
          item.vanLine3.forEach((i) => {
            i.pickup_location = data.pickup_location;
            i.delivery_location = data.delivery_location;
            i.pickup_date = checkDateToFormatDynamic(
              data.pickUpDate + " " + data.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
            i.delivery_date = checkDateToFormatDynamic(
              data.deliveryDate + " " + data.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          });
        });
      } else if (data.service_type.toString() == "5") {
        data.valueContainer.forEach((item, idx) => {
          item.containerLine3.forEach((i) => {
            i.deport = data.deport;
            i.pickup_location = data.pickup_location;
            i.delivery_location = data.delivery_location;
            i.pickup_date = checkDateToFormatDynamic(
              data.pickUpDate + " " + data.pickUpTime,
              "DD-MM-YYYY HH:mm"
            );
            i.delivery_date = checkDateToFormatDynamic(
              data.deliveryDate + " " + data.deliveryTime,
              "DD-MM-YYYY HH:mm"
            );
          });
        });
      } else if (data.service_type.toString() == "3") {
        data.showAddMore.forEach((item, idx) => {
          item.lclLine3.forEach((i) => {
            i.pickup_location = data.pickup_location;
            i.delivery_location = data.delivery_location;

            
            i.pickup_date = checkDateToFormatDynamic(
              data.inland_pick_up_date + " " + data.inland_pick_up_time,
              "DD-MM-YYYY HH:mm"
            );
            i.delivery_date = checkDateToFormatDynamic(
              data.inland_delivery_date + " " + data.inland_delivery_time,
              "DD-MM-YYYY HH:mm"
            );
          });
        });
      }


      console.log(JSON.stringify(data));

      this.$loading.show();

      useJwt
        .put("wr1?objectType=UpdateShipmentDetail", data)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Update successfully",
          });
          this.$emit("RequestAnUpdateEvent");
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
  },
};
</script>

<style lang="scss">
.vue-dropzone > .dz-preview .dz-details {
  background-color: #2b938c;
  border-radius: 15px;
}
.btn-custom-round {
  border-radius: 10px;
}
.custom-mt {
  margin-top: 4rem;
}
.shipment-detail {
  margin-bottom: 8rem;
}
</style>
